module.exports = __webpack_public_path__ + "img/search.e93bceb9.svg";